import { api } from '../../../shared/api/client';

export const calculateProfit = (params = {}) => api.post('dashboard/calculateProfit', params);
export const getDataPayInToDay = () => api.get('dashboard/getDataPayInToDay');
export const getStatistic = (params) => api.post('dashboard/getStatistic', params);
